import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useTitle from '../hooks/useTitle';
import HeroSlider from '../components/HeroSlider';
import StatsStrip from '../components/StatsStrip';
import ServiceExplorer from '../components/ServiceExplorer';
import WhyBanner from '../components/WhyBanner';
import ProcessSteps from '../components/ProcessSteps';
import WorkCarousel from '../components/WorkCarousel';
import IndustryGrid from '../components/IndustryGrid';
import Faq from '../components/Faq';
import CtaBand from '../components/CtaBand';
import ContactSection from '../components/ContactSection';

export default function Home() {
  useTitle('ISL Tech — Custom software and production AI');
  const { hash } = useLocation();

  // Scroll to the anchor when arriving from another route (e.g. /privacy → /#contact).
  useEffect(() => {
    if (!hash) return undefined;
    const id = hash.slice(1);
    const t = setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 80);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <>
      <HeroSlider />
      <StatsStrip />
      <ServiceExplorer />
      <WhyBanner />
      <ProcessSteps />
      <WorkCarousel />
      <IndustryGrid />
      <Faq />
      <CtaBand />
      <ContactSection />
    </>
  );
}
